module.exports={root:{groups:[{tags:[],phrases:["The [name] system is completely empty of life."]}]}};